"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.701 2.001a3.7 3.7 0 0 0-3.7 3.7V14.3a3.7 3.7 0 0 0 3.7 3.7h4.3a.7.7 0 1 0 0-1.4H5.7a2.3 2.3 0 0 1-2.3-2.3V7.05h13.2V10a.7.7 0 1 0 1.4 0V5.701a3.7 3.7 0 0 0-3.7-3.7zm10.898 3.65H3.402A2.3 2.3 0 0 1 5.7 3.4h8.6a2.3 2.3 0 0 1 2.299 2.25m-3.949 7.8a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.723 13.26a.76.76 0 1 1-1.519 0 .76.76 0 0 1 1.519 0m0-3.26a.76.76 0 1 1-1.519 0 .76.76 0 0 1 1.519 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.637 12.11a2.063 2.063 0 1 0-3.986 1.068 2.063 2.063 0 0 0 3.986-1.068m-2.89-2.812a3.463 3.463 0 0 1 3.79 5.249l1.458 1.458a.7.7 0 1 1-.99.99l-1.457-1.457a3.463 3.463 0 1 1-2.8-6.24",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=GoToDateIcon20.js.map